import { createSelector } from "reselect";
import { RootState } from "../../core/app/store";

const metadataState = (state:RootState) => state?.metadataReducer;

export const getMetadata = createSelector([metadataState], (state) => state?.metadata);

